import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faCaretRight, faSave, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import Axios from 'axios';
import {Alert, Logout, BaseURL, DConnect, DecryptData, PostOptions} from '../../components/Config';

function Financials(props){
    const [registration, setRegistration] = useState(props.registration);
    const [position, setPosition] = useState(props.position);
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [financials, setFinancials] = useState (props.financials);
    const [save, setSave] = useState(false);
    const [stat2019, setStat2019] = useState({statement:'', imageUrl:'', ex:''});
    const [stat2020, setStat2020] = useState({statement:'', imageUrl:'', ex:''});
    const [dropdowns, setDropdowns] = useState({'raised_capital':[],'capital_status':[], 'paymodes':[], 'msdn':[]});
    const [maxEntry, setMaxEntry]    =  useState(['20000','25000','200000']);
    const [formType, setFormType]    =  useState(0);
    useEffect(() => {
        props.getProps(props);
        setRegistration(props.registration);
        setBusinessDetails(props.businessDetails);
        setFinancials(props.financials);
        setDropdowns(props.dropdowns);
    
        
    }, []);

   

    const handleChange = (e) => {
        e.preventDefault();

        const {name, value} = e.target;

        if(['getp3requested_amt'].includes(name) && value < 0){
            setFinancials(prevState => ({ ...prevState, [name]:0 }));
        }else{
            setFinancials(prevState => ({ ...prevState, [name]:value }));
        }
    }

    const imageChange = (e) => {
        e.preventDefault();

        const {name, value} = e.target;

        let reader = new FileReader();
        let file = e.target.files[0];
        let ext = file.name.split('.');

        setFinancials(prevState => ({...prevState, [name]:`${businessDetails.app_num}_${name}.${ext[ext.length-1]}`}));

        reader.onloadend = () => {
            let image = {statement:file, imageUrl: reader.result, ext:ext[ext.length-1]};
            
            if(name === 'statement_2019'){
                setStat2019(image);
            }else{
                setStat2020(image);
            }
        }

        reader.readAsDataURL(file);
    }

    const submitForm = (e) => {
        e.preventDefault();

        if(financials.id == 0){ financials.app_num = businessDetails.app_num; }
        if(financials.previous_loan == ''){ financials.previous_loan = 0; }
        if(financials.loan_default == ''){ financials.loan_default = 0; }

        props.handleChange(7, financials);
        
        let options = (financials.id == 0) ? PostOptions('POST', financials, 'financing')
        : PostOptions('PUT', financials, `financing/${financials.id}`);
        
        Axios(options).then(res => {
            let resdata = DecryptData(res.data);
          
            if(resdata.id !== undefined){
                financials['id'] = resdata.id;
                props.handleChange(7, financials);
            }

            position.app_num = registration.app_num;
            position.ma_stage = position.ma_stage < 6 ? 6: position.ma_stage;
            props.handleChange(14, position);
            options = (position.id == 0) ? PostOptions('POST', position, 'appstage')
            : PostOptions('PUT', position, `appstage/${position.id}`);
            Axios(options).then(resD => {
                let resData = DecryptData(resD.data); 

                if (resData.id !== undefined) {
                    position['id'] = resData.id;
                    props.handleChange(14, position);
                }
             })    
        }).catch(error => {Alert({title:'Financials',message:error.message, buttons:[{label:'Ok'}]}); });
        if(save){
        Logout()
        window.location.reload()
        }else{
        props.doNavigate(props,6,1);
        }
   
    }


    return(
        <div className="content">
            <h5>Financial <span>Details</span></h5><br />
            <form id="frmFinancials" method="POST" onSubmit={submitForm}>
                <div className="row">
                    
                    <div className="col-xs-12 col-6 ">
                        {/* {[0].includes(apptype) && <div className="form-group">
                            <label for="paymode">Mode of Grants Payment</label>
                            <select className="form-control custom-select" id="paymode" name="paymode"
                                value={financials.paymode} onChange={handleChange}>
                                <option value=""> -- Select Preferred -- </option>
                                {dropdowns.paymodes.map(pmode => (
                                    <option value={pmode.ivalue}>{pmode.iname}</option>
                                ))}
                            </select>
                        </div>} */}
                       
                        {/* <div className="form-group">
                            <label for="bankname"><strong>Bank name:</strong></label><span className="required">*</span>
                            <input type="text" min="0" step="any" className="form-control" id="bankname" name="bankname" required="required" 
                            value={financials.bankname} onChange={handleChange} />
                        </div>
                       
                        <div className="form-group">
                            <label for="accountname"><strong>Account name:</strong></label><span className="required">*</span>
                            <input type="text" min="0" step="any" className="form-control" id="accountname" name="accountname" required="required" 
                            value={financials.accountname} onChange={handleChange} />
                        </div> */}
                        {/* {financials.paymode == 2 && 
                        <div className="form-group">
                            <label for="momo_num"><strong>Mobile Money Number:</strong></label><span className="required">*</span>
                            <input type="tel" min="0" step="any" className="form-control" id="momo_num" name="momo_num" required="required" 
                            value={financials.momo_num} onChange={handleChange} />
                        </div>} */}
                    </div>
                    
                    <div className="col-xs-12 col-md-6 ">
                        
                        {/* <div className="form-group">
                            <label for="accountno"><strong>Account Number:</strong></label><span className="required">*</span>
                            <input type="text" min="0" step="any" className="form-control" id="accountno" name="accountno" required="required" 
                            value={financials.accountno} onChange={handleChange} />
                        </div>
                        
                        <div className="form-group">
                            <label for="branch"><strong>Bank Branch:</strong></label><span className="required">*</span>
                            <input type="text" min="0" step="any" className="form-control" id="branch" name="branch" required="required" 
                            value={financials.branch} onChange={handleChange} />
                        </div> */}
                        {/* <div className="form-group">
                            <label for="accopeningyear">Year bank account was opened:</label>
                            <input type="number" min="1970" max="2022" className="form-control" id="accopeningyear" name="accopeningyear" required="required" 
                            value={financials.accopeningyear} onChange={handleChange} />
                        </div> */}
                        {/* {financials.paymode == 2 && 
                        <div className="form-group">
                            <label for="momo_name"><strong>Mobile Money registered name:</strong></label><span className="required">*</span>
                            <input type="text" min="0" step="any" className="form-control" id="momo_name" name="momo_name" required="required" 
                            value={financials.momo_name} onChange={handleChange} />
                        </div>}
                        {financials.paymode == 2 && 
                        <div className="form-group">
                            <label for="msdn"><strong>Mobile Network:</strong></label><span className="required">*</span>
                            <select className="form-control custom-select" id="msdn" name="msdn"
                                value={financials.msdn} onChange={handleChange}>
                                <option value=""> -- Select Preferred -- </option>
                                {dropdowns.msdn.map(mn => (
                                    <option value={mn.ivalue}>{mn.iname}</option>
                                ))}
                            </select>
                        </div>} */}
                    </div>
                   
                   
                   
                    <div className="col-xs-12 col-md-6 ">
                        <div className="form-group">
                            <label for="loan_default">Has your business benefited from any grant program?</label>
                            <select className="form-control custom-select" id="isrecievedgrantbefore" name="isrecievedgrantbefore"
                                value={financials.isrecievedgrantbefore} onChange={handleChange} required="required">
                                <option value=""> -- Choose Option -- </option>
                                <option value={0}>No</option>
                                <option value={1}>Yes</option>
                            </select>
                        </div>
                        {financials.isrecievedgrantbefore == 1 && <> <div className="form-group">
                            <label for="loan_default">If ‘Yes’, state name of the Grant Awarding Organization, amount received and year when the grant was received</label>
                        </div>
                        <div className="form-group">
                            <label for="grantawardingorg">Grant Awarding Organization:</label>
                            <input type="text"  className="form-control" id="grantawardingorg" name="grantawardingorg" required="required" 
                            value={financials.grantawardingorg} onChange={handleChange} required="required" />
                        </div><div className="form-group">
                            <label for="awardamount">Amount Received:</label>
                            <input type="number" step="any" className="form-control" id="awardamount" name="awardamount" required="required" 
                            value={financials.awardamount} onChange={handleChange} required="required" />
                        </div><div className="form-group">
                            <label for="awardyear">Award Year:</label>
                            <input type="number" min="2000" className="form-control" id="awardyear" name="awardyear" required="required" 
                            value={financials.awardyear} onChange={handleChange} required="required" />
                        </div></>}
                        {/* <div className="form-group">
                            <label for="statement_2020">2020 Bank or Financial Statement</label>
                            <br /> <small className="text-primary">You can upload only images(JPG, JPEG, PNG)</small>
                            <div id="statement_2020Con" className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                                {financials.statement_2020 === '' ? 'Click here to add' : 
                                (![undefined,null].includes(financials.statement_2020) && (financials.statement_2020).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                : <img src={(stat2020.imageUrl !== '') ? stat2020.imageUrl : `${BaseURL()}static/${financials.statement_2020}`} style={{height:'120px'}} /> }
                            </div>
                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png" id="statement_2020" name="statement_2020" style={{display:'none'}} 
                            onChange={imageChange} />
                        </div> */}
                    </div>
                    <div className="col-xs-12 col-md-6 " />
                       <div className="col-12">
                            <div className="form-group">
                                <label for="getp3requested_amt"><strong>Requested Grant Amount (GHS):</strong></label><span className="required">*</span>
                                <input type="number" min="1" step="any" className="form-control" id="getp3requested_amt" name="getp3requested_amt" required="required" 
                                value={financials.getp3requested_amt} onChange={handleChange} />
                            </div>
                        </div>
                    </div>
                </form>
                <button className="btn btn-bg btn-outline text-white" style={{padding:'10px 20px',borderRadius: '20px', marginTop: '25px'}} onClick={() => props.doNavigate(props,5,0)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /> &nbsp; Go Back </button>
                <button type="submit" form="frmFinancials"  className="btn btn-bg btn-outline text-white float-right" style={{padding:'10px 20px', borderBottomRightRadius: '20px', borderTopRightRadius: '20px', marginTop: '25px'}}>Save &amp; Next &nbsp; <FontAwesomeIcon icon={faCaretRight} size="lg"  /></button>
                <button type="submit" form="frmFinancials" onClick={()=>setSave(true)} className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomLeftRadius: '20px', borderTopLeftRadius: '20px', marginRight: '5px', marginTop: '25px' }}>Save &amp; Close &nbsp; <FontAwesomeIcon icon={faSave} size="lg" /></button>
        </div>
    )
}

export default Financials;